import React from 'react'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage, showLayer } from '@/utils/layer'
import Table, { ColumnsType } from 'antd/lib/table'
import { Row } from '@/components/layout/layout'
import StockJoinDetail from '../../../../stock-manage/stock-join/stock-join-detail/stock-join-detail'
import { IStockInOrder } from './type'

interface OrderInInfoProps {
    list?: IStockInOrder[]
}

const OrderInInfo: React.FC<OrderInInfoProps> = props => {
    const columns: ColumnsType<IStockInOrder> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '入库单号',
            key: 'order_no',
            dataIndex: 'order_no',
        },
        {
            title: '操作人',
            key: 'creator',
            dataIndex: 'creator',
            ellipsis: true,
            render: val => (
                <Row data-align-items-center>
                    <img src={val.user.avatar} alt="" className="avatar" />
                    <div data-margin-left-4> {val.user.realname || val.user.nickname}</div>
                </Row>
            ),
        },
        {
            title: '入库状态',
            dataIndex: 'stocked_in',
            render: val => (val ? '已入库' : '未入库'),
        },
        {
            title: '操作',
            key: 'action',
            width: 90,
            align: 'center',
            render: (val, record) => (
                <span
                    className="action"
                    onClick={() => {
                        layerManage.popAll()
                        showLayer(<StockJoinDetail id={record.id} />)
                    }}
                >
                    详情
                </span>
            ),
        },
    ]

    return (
        <BaseDialog
            isShow
            styles={{
                width: '570px',
            }}
            title="关联入库单"
            onClose={() => {
                layerManage.pop()
            }}
        >
            <div
                style={{
                    width: '540px',
                    margin: '15px',
                }}
            >
                <Table bordered pagination={false} columns={columns} dataSource={props.list} rowKey={r => r.id} />
            </div>
        </BaseDialog>
    )
}

export default OrderInInfo
